/*globals jQuery, document */

/*
    Add toggle to foreign student fields
    Cfr. https://trac.portaal.ugent.be/ticket/1726
*/

jQuery(function ($) {
    
    $(document).ready(function () {
      if ($('.formid-doctoraat-toevoegen #buitenlandse-student').is(":not(':checked')")) {
        $('.formid-doctoraat-toevoegen #archetypes-fieldname-diploma-opgehaald').hide();                
        $('.formid-doctoraat-toevoegen #archetypes-fieldname-adres-buitenlandse-student').hide();       
      }

      $('.formid-doctoraat-toevoegen #buitenlandse-student').click(function() {                      
          $('.formid-doctoraat-toevoegen #archetypes-fieldname-diploma-opgehaald').toggle(350);
          $('.formid-doctoraat-toevoegen #archetypes-fieldname-adres-buitenlandse-student').toggle(350);
      });
      
      $('.formid-doctoraat-toevoegen #diploma-opgehaald').click(function() {                      
          $('.formid-doctoraat-toevoegen #archetypes-fieldname-adres-buitenlandse-student').toggle(350);
      });
      
    });
});
